const EN_US = {
  //-- Common --//

  // Titles
  'storeInterventionsDomain.storeInterventions.title': 'Store Interventions',
  'storeInterventionsDomain.closureRequest.title': 'Closure Requests',

  // Environment Message
  'storeInterventionsDomain.header.stagingEnvText':
    'You are on the staging environment. Changes here will have no impact to live systems.',

  // Side Panel
  'storeInterventionsDomain.sidePanel.done.label': 'Done',
  'storeInterventionsDomain.sidePanel.close.label': 'Close',

  // Request Status
  'storeInterventionsDomain.requestStatus.newRequest': 'New',
  'storeInterventionsDomain.requestStatus.wontDo': "Won't Do",
  'storeInterventionsDomain.requestStatus.interventionCreated': 'Created',
  'storeInterventionsDomain.requestStatus.interventionCompleted': 'Completed',
  'storeInterventionsDomain.requestStatus.duplicate': 'Duplicate',
  'storeInterventionsDomain.requestStatus.expired': 'Expired',

  //-- Store Intervention Create Request Page --//
  // Form Actions
  'storeInterventionsDomain.createRequest.form.actions.cancel': 'Cancel',
  'storeInterventionsDomain.createRequest.form.actions.next': 'Next',
  'storeInterventionsDomain.createRequest.form.actions.back': 'Back',
  'storeInterventionsDomain.createRequest.form.actions.review': 'Review',
  'storeInterventionsDomain.createRequest.form.actions.submit': 'Submit',

  // Header card
  'storeInterventionsDomain.createRequest.headerCard.title': 'Request for Store Intervention',
  'storeInterventionsDomain.createRequest.headerCard.description':
    'Start by searching for a store by the location ID or retailer name and store number.',

  // Nav
  'storeInterventionsDomain.createRequest.pageHeader': 'Intervention Request',
  'storeInterventionsDomain.createRequest.nav.step1': 'Step 1: Search for Store',
  'storeInterventionsDomain.createRequest.nav.step2': 'Step 2: Request Details',
  'storeInterventionsDomain.createRequest.nav.step3': 'Step 3: Review & Submit',

  // Step One
  'storeInterventionsDomain.createRequest.searchForStore.warehouseLocationId': 'WHL ID',
  'storeInterventionsDomain.createRequest.searchForStore.retailerNameAndLocationCode':
    'Retailer Name & Location Code',
  'storeInterventionsDomain.createRequest.searchForStore.retailer': 'Retailer',
  'storeInterventionsDomain.createRequest.searchForStore.retailerNoOptionsMessage':
    'Type to start searching retailers',

  // Cancel Modal
  'storeInterventionsDomain.createRequest.cancelModal.title': 'Are you sure you want to cancel?',
  'storeInterventionsDomain.createRequest.cancelModal.description': 'All changes will be lost.',
  'storeInterventionsDomain.createRequest.cancelModal.cancel': 'Cancel',
  'storeInterventionsDomain.createRequest.cancelModal.goBack': 'Go back',

  // Locations grid
  'storeInterventionsDomain.createRequest.locationsGrid.loadingRetailerName':
    'Loading Retailer Name...',
  'storeInterventionsDomain.createRequest.locationsGrid.header.whlId': 'WHL ID',

  //-- Store Interventions Requests List Page --//

  // Request Insights
  'storeInterventionsDomain.requestInsight.title': 'Request Insight ',
  'storeInterventionsDomain.requestInsight.description': 'Showing insights for the last 24 hours',

  // Requests Grid
  'storeInterventionsDomain.requestsList.grid.requestId': 'Request ID',
  'storeInterventionsDomain.requestsList.grid.retailerName': 'Retailer Name',
  'storeInterventionsDomain.requestsList.grid.DateCreated': 'Date Created',
  'storeInterventionsDomain.requestsList.grid.priority': 'Priority',
  'storeInterventionsDomain.requestsList.grid.status': 'Status',
  'storeInterventionsDomain.requestsList.grid.loading': 'Loading...',
  'storeInterventionsDomain.requestsList.grid.requestCount': 'Requests ({requestCount})',
  'storeInterventionsDomain.requestsList.grid.noResults':
    'No request found. Try changing or removing some of the filters.',
  'storeInterventionsDomain.requestsList.grid.allRecordsOnPageSelected':
    'All {numberOfRecords} requests on this page have been selected',
  'storeInterventionsDomain.requestsList.grid.numberOfRecordsSelected':
    '{numberOfRecords} requests(s) selected',
  'storeInterventionsDomain.requestsList.grid.unselectAll': 'Unselect all',
  'storeInterventionsDomain.requestsList.grid.edit': 'Edit',
  'storeInterventionsDomain.requestsList.grid.ignore': 'Ignore',
  'storeInterventionsDomain.requestsList.grid.delete': 'Delete',
  'storeInterventionsDomain.requestsList.grid.stop': 'Stop',
  'storeInterventionsDomain.requestsList.grid.createIntervention': 'Create Intervention',

  // Filter Panel
  'storeInterventionsDomain.requestsList.filterPanel.buttonLabel': 'Filters',
  'storeInterventionsDomain.requestsList.filterPanel.header': 'Filters',
  'storeInterventionsDomain.requestsList.filterPanel.requests': 'Requests',
  'storeInterventionsDomain.requestsList.filterPanel.close': 'Close',
  'storeInterventionsDomain.requestsList.filterPanel.done': 'Done',
  'storeInterventionsDomain.requestsList.filterPanel.warehouse': 'Warehouse',
  'storeInterventionsDomain.requestsList.filterPanel.noOptionsMessage': 'Type to start searching',
  'storeInterventionsDomain.requestsList.filterPanel.address': 'Address',
  'storeInterventionsDomain.requestsList.filterPanel.createdDate': 'Created Date',
  'storeInterventionsDomain.requestsList.filterPanel.startDate': 'Start Date',
  'storeInterventionsDomain.requestsList.filterPanel.requester': 'Requester',
  'storeInterventionsDomain.requestsList.filterPanel.requestId': 'Request ID',
  'storeInterventionsDomain.requestsList.filterPanel.changeType': 'Change Type',
  'storeInterventionsDomain.requestsList.filterPanel.priority': 'Priority',
  'storeInterventionsDomain.requestsList.filterPanel.zone': 'Zone',
  'storeInterventionsDomain.requestsList.filterPanel.stateOfWhl': 'State of WHL',
  'storeInterventionsDomain.requestsList.filterPanel.statusOfRequest': 'Status of request',
  'storeInterventionsDomain.requestsList.filterPanel.warehouseLocationId': 'WHL ID',

  // Request Details Panel
  'storeInterventionsDomain.requestDetailsPanel.header': 'Request Details',

  //-- Filters --//
  'storeInterventionsDomain.filters.search': 'Search',
  'storeInterventionsDomain.filters.dateRange': 'Date range',
  'storeInterventionsDomain.filters.noDateSelected': 'No date selected',

  // Warehouse Location Search
  'storeInterventionsDomain.filters.warehouseLocationSearch.error.errorFetchingWarehouseLocations':
    'An error occurred while fetching the requested warehouse locations.',
  'storeInterventionsDomain.filters.warehouseLocationSearch.notification.warehouseLocationsNotFound':
    'There were no warehouse locations found for the following requested WHL IDs:',
} as const

export default EN_US
